"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxeTier = void 0;
function getAxeTier(dna) {
    if (hasKey(dna, 'uniqueId'))
        return getAxeTier(dna.uniqueId);
    if (hasKey(dna, 'id'))
        return getAxeTier(dna.id);
    return Number(dna[0]);
}
exports.getAxeTier = getAxeTier;
function hasKey(obj, key) {
    return !!obj[key];
}
//# sourceMappingURL=tier.js.map